var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandmarkin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M10.8 0v9.6h-3l4.2 5.625L16.2 9.6h-3V0h-2.4zM6.675 1.313C2.695 3.304 0 7.34 0 12c0 6.642 5.358 12 12 12s12-5.358 12-12c0-4.66-2.644-8.808-6.675-10.688l-1.05 2.175C19.444 4.97 21.6 8.26 21.6 12c0 5.358-4.242 9.6-9.6 9.6S2.4 17.358 2.4 12c0-3.74 2.105-6.905 5.325-8.512l-1.05-2.175z",
    opacity: 0.626
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarkin);
export default __webpack_public_path__ + "static/media/landmarkin.df473d15c78f29f84bb27aa5228fbacb.svg";
export { ForwardRef as ReactComponent };